import { useState } from "react";
import { IconButton, Popover, Typography, Box, Tooltip } from "@mui/material";
import moment from "moment";
import TableComponent from "../../../layoutComponents/TableComponent";
import { Info } from "@mui/icons-material";
import { CrossIcon } from "../../../styles/Icons";
const TotalPayments = ({ tableList, data }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "formula-popover" : undefined;
  const generateMergedList = (item) => {
    return item.map((singleSub) => {
      singleSub["Date"] = moment(singleSub.payment_date).format(
        "ddd, MMM Do YYYY"
      );
      singleSub["Payment Id"] = singleSub.payment_id;
      singleSub["Payment Amount"] = singleSub.paid_bills.find(
        (s) => s.miller_account === data.id
      )
        ? `₹ ${Number(
            singleSub.paid_bills.find((s) => s.miller_account === data.id)
              .allocated_to_bill
          ).toFixed(0)}/-`
        : "";
      singleSub["Payment Status"] = singleSub.payment_status;
      singleSub["Recorded By"] = singleSub.recorded_by;
      singleSub["Verified By"] = singleSub.verified_by;
      return singleSub;
    });
  };
  return (
    <>
      {tableList.length > 0 ? (
        <IconButton
          size="small"
          onClick={handleOpen}
          sx={{ padding: "0 0 0 4px" }}
        >
          <Info fontSize="inherit" />
        </IconButton>
      ) : (
        ""
      )}
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Box>
          <Box
            sx={{
              p: 2,
              pb: "0",
              display: "flex",
              flexDirection: "row",
              width: "100%",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            {" "}
            <Typography fontSize="0.8rem" fontWeight="bold" mb={1}>
              Payment Details
            </Typography>
            <Tooltip title="close" arrow placement="top">
              <IconButton
                style={{ padding: "5px", borderRadius: "5px" }}
                onClick={handleClose}
              >
                <CrossIcon strokeWidth="2" color={"black"} />
              </IconButton>
            </Tooltip>
          </Box>
          <Box sx={{ height: "334px" }}>
            <TableComponent
              noSearchBar={true}
              descending={true}
              header={[
                "Sr.No.",
                "Date",
                "Payment Id",
                "Payment Amount",
                "Recorded By",
                "Verified By",
              ]}
              noAddButton
              // HEADERS[userRole] || HEADERS.default}
              tableList={generateMergedList(tableList)}
              // tableList.map((item) => setData(item, userRole))}
              actions={[]}
            />
          </Box>
        </Box>
      </Popover>
    </>
  );
};

export default TotalPayments;
